/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

var commonProps = {
  files: Array,
  toUploadFiles: Array,
  displayFiles: Array,
  theme: String,
  abridgeName: Array,
  placeholder: String,
  classPrefix: String,
  tips: String,
  status: String,
  locale: Object,
  sizeOverLimitMessage: String,
  autoUpload: Boolean,
  disabled: Boolean,
  uploading: Boolean,
  tipsClasses: [String, Array, Object],
  errorClasses: [String, Array, Object],
  "default": Function,
  fileListDisplay: Function,
  onRemove: Function
};

export { commonProps, commonProps as default };
//# sourceMappingURL=constants.js.map
